import React from 'react'
import { Button, Typography, Container } from '@mui/material'
import leftGreetingIcon from '../../../images/leftGreetingIcon.svg' 
import rightGreetingIcon from '../../../images/rightGreetingIcon.svg'
import FeedSearchModal from './FeedSearchModal'
import styles from '../../../pages/Dashboard.module.scss'

export default function DashboadGreeting({user}) {
    const date = new Date().getHours()

    const greeting =  date < 12 ? "Good Morning": date <18 ?"Good Afternoon":"Good Evening"
    
    return (
        <section className={styles['lagoon-welcome']}>
            <img src={leftGreetingIcon} alt="greeting left style icon" className={`${styles['svgIcon']} ${styles['svgIcon-left']}`}/>
            <Container maxWidth="xl" className={styles['content']}>
                <div className={styles['lagoon-welcome-text']}>   
                    <Typography variant="h1" className={styles['lagoon-title']}>{greeting}, {user?.name?.split(' ')[0]}</Typography>
                    <Typography className={styles['lagoon-supTitle']}>Generate a competitive edge with the power of data</Typography>
                </div>
                <FeedSearchModal Type='Dashboard'>
                    {/* <Button color="primary" variant="contained" size="large">+ Add New Research</Button> */}
                    <Button color="primary" variant="contained" size="large">Search for a Stock</Button>
                </FeedSearchModal>
            </Container>
            <img src={rightGreetingIcon} alt="greeting left style icon" className={styles['svgIcon']}/>
        </section>
    )
}
